import { NonIdealState } from '@blueprintjs/core';
import { DateToLocal } from 'components/dates';
import { ShowHide } from 'components/layout';
import { Table } from 'components/listing';
import { StatusBlock } from 'components/status';
import PropTypes from 'prop-types';
import React, { Fragment, useState, useEffect } from 'react';

export function EmployeeLicenceBureauEndorsements(
    {
        licenceCheck = null,
        ...props
    }
) {
    const headerData = {
        headers: [
            {
                key: 'STATUS',
                value: 'Status'
            },
            {
                key: 'CODE', 
                value: 'Code'
            },
            {
                key: 'OFFENCE',
                value: 'Offence date'
            },
            {
                key: 'CONVICTION',
                value: 'Conviction date'
            },
            {
                key: 'INACTIVE',
                value: 'DVLA inactive date'
            },
            {
                key: 'POINTS',
                value: 'Number of points'
            },
            {
                key: 'DISQUALIFIED',
                value: 'Resulted in disqualification'
            }
        ]
    };
    const [data, setData] = useState([]);

    useEffect(formatData, [licenceCheck]);

    function formatData() {
        let formattedData = [];

        if (licenceCheck?.endorsements) {
            formattedData = licenceCheck.endorsements
                .map((x, index) => {

                    const rowKey = `${x.code}-${x.offenceDate}`;

                    return {
                        cells: [
                            <StatusBlock key={rowKey} large={false} bold={false} status={getStatusForEndorsement(x)}>{getStatusForEndorsement(x)}</StatusBlock>,
                            x.code,
                            <DateToLocal key={rowKey} format='DD/MM/YYYY'>{x.offenceDate}</DateToLocal>,
                            <DateToLocal key={rowKey} format='DD/MM/YYYY'>{x.convictionDate}</DateToLocal>,
                            <DateToLocal key={rowKey} format='DD/MM/YYYY'>{x.dvlaInactiveDate}</DateToLocal>,
                            x.noOfPoints,
                            x.isDisqual ? <Fragment key={rowKey}>{'Yes until '}<DateToLocal format='DD/MM/YYYY'>{x.disqualEndDate}</DateToLocal></Fragment> : 'No'
                        ],
                        key: index
                    };
                });
        }

        setData(formattedData);
    }

    function getStatusForEndorsement(endorsement) {
        if (endorsement.dvlaInactiveDate) {
            const formattedInactiveDate = new Date(endorsement.dvlaInactiveDate);
            const today = new Date();

            return formattedInactiveDate > today ? 'Active' : 'Inactive';
        }

        return 'Active';
    }

    return <div className='spacer-top-small'>
        <ShowHide
            evaluator={data.length > 0}
            show={
                <Table
                    headerData={headerData}
                    data={data}
                    loadingData={false}
                    fitToContent={false}
                />
            }
            hide={
                <NonIdealState
                    description={"No valid endorsements exist for this employee in Licence Bureau."}
                />
            }
        />
    </div>;
}

EmployeeLicenceBureauEndorsements.propTypes = {
    licenceCheck: PropTypes.object
};